import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";

// 🌐 PUBLICO
import Home from "./components/Home";
import Servicios from "./components/Servicios";
import SignUp from "./components/SignUp";
import Login from "./components/Login";
import WelcomePet from "./components/WelcomePet";
import PerfilMascota from "./components/PerfilMascota";
import Interfaz from "./components/Interfaz";
import Informascota from "./components/Informascota";
import Terminos from "./components/Terminos";
import Privacidad from "./components/Privacidad";
import Reembolsos from "./components/Reembolsos";
import Carnet from "./components/Carnet";
import TuPlan2 from "./components/TuPlan2";
import AnadirMascota from "./components/AñadirMascota";
import ResetPassword from "./components/ResetPassword";
import CarnetPublic from "./components/CarnetPublic";
import PagoWompi from "./components/PagoWompi";
import PagoEpayco from "./components/PagoEpayco";

// 🛠️ ADMIN
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminUserDetail from "./pages/admin/AdminUserDetail";
import AdminPets from "./pages/admin/AdminPets";
import AdminPetDetail from "./pages/admin/AdminPetDetail";
import AdminAllies from "./pages/admin/AdminAllies";
import AdminAllyDetail from "./pages/admin/AdminAllyDetail";
import CreateAlly from "./pages/admin/CreateAlly";
import ProtectedAdminRoute from "./components/admin/ProtectedAdminRoute";

function App() {
  const location = useLocation();
  console.log("API:", process.env.REACT_APP_API_BASE_URL);

  useEffect(() => {
    const isFreeScroll =
      location.pathname === "/" ||
      location.pathname === "/servicios" ||
      location.pathname.startsWith("/admin");

    const html = document.documentElement;
    const body = document.body;

    if (isFreeScroll) {
      html.style.overscrollBehavior = "";
      body.style.overscrollBehavior = "";
    } else {
      html.style.overscrollBehavior = "none";
      body.style.overscrollBehavior = "none";
    }

    return () => {
      html.style.overscrollBehavior = "";
      body.style.overscrollBehavior = "";
    };
  }, [location.pathname]);

  return (
    <div className="app-shell">
      <ScrollToTop />

      <Routes>
        {/* 🌍 PUBLICAS */}
        <Route path="/" element={<Home key={location.pathname} />} />
        <Route path="/servicios" element={<Servicios key={location.pathname} />} />

        <Route path="/crear-cuenta" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/welcomepet" element={<WelcomePet />} />
        <Route path="/perfilmascota" element={<PerfilMascota />} />
        <Route path="/interfaz" element={<Interfaz />} />
        <Route path="/informascota" element={<Informascota />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/reembolsos" element={<Reembolsos />} />
        <Route path="/carnet" element={<Carnet />} />
        <Route path="/tu-plan" element={<TuPlan2 />} />
        <Route path="/anadirmascota" element={<AnadirMascota />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/carnet/public/:publicId" element={<CarnetPublic />} />
        <Route path="/pago-wompi" element={<PagoWompi />} />
        <Route path="/pago-epayco" element={<PagoEpayco />} />

        {/* 🛠️ ADMIN PROTEGIDO */}
        <Route
          path="/admin"
          element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />

          {/* Usuarios */}
          <Route path="usuarios" element={<AdminUsers />} />
          <Route path="usuarios/:id" element={<AdminUserDetail />} />

          {/* Mascotas */}
          <Route path="mascotas" element={<AdminPets />} />
          <Route path="mascotas/:id" element={<AdminPetDetail />} />

          {/* Aliados */}
          <Route path="aliados" element={<AdminAllies />} />
          <Route path="aliados/crear" element={<CreateAlly />} />
          <Route path="aliados/:id" element={<AdminAllyDetail />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;